import React from "react";
import { getKpiReport } from "../api/kpi";
import KpiReportContent from "../components/KpiReport/KpiReportContent";
import { KpiReportLoader } from "../components/KpiReport/KpiReportLoader";

// The client-facing KPI report. One request: the backend decides, through its
// ActiveUsersV2 flag, whether this is the current report or the corrected one, and
// sends the V1 vs V2 comparison along only when it is the corrected one.
const KpiReport: React.FC = () => (
  <KpiReportLoader load={getKpiReport}>
    {(data) => (
      <KpiReportContent
        data={data}
        csvFilePrefix="kpi-report"
        activeUsersComparison={data.activeUsersComparison}
      />
    )}
  </KpiReportLoader>
);

export default KpiReport;
